import { RegisterAssessmentReviewComponent } from "./register-assessment-review.component";
import { ConfirmReviseComponent } from "./shared-components/confirm-revise/confirm-revise.component";
export const RegisterAssessmentReviewModule = [
    RegisterAssessmentReviewComponent,
    ConfirmReviseComponent
]
